import React, { useCallback, useState } from 'react';
import BiOption from '@wix/da-bi/pkg/Components/BiOption';
import { useBiLogger } from '@wix/da-bi/pkg/hooks/useBiLogger';
import { isDropdownGroup, findSelectedItem } from '../helpers';
import { useDropdownItems } from '../hooks/useDropdownItems';
import { useDeepEqualMemo } from '@wix/da-hooks/dist/src/useDeepEqualMemo';
var DUMMY_OPTION = {
    selected: true,
    disabled: true,
    hidden: true,
    value: 'null',
    label: '',
};
var NativeDropdown = function (_a) {
    var items = _a.items, onSelect = _a.onSelect, onClick = _a.onClick, className = _a.className, name = _a.name, biData = _a.biData, _b = _a.openBiData, openBiData = _b === void 0 ? biData : _b, _c = _a.closeBiData, closeBiData = _c === void 0 ? biData : _c;
    var filteredItems = useDropdownItems(items).filteredItems;
    var selectedItem = findSelectedItem(filteredItems);
    var _d = useState(false), isOpen = _d[0], setOpen = _d[1];
    var logBiEvent = useBiLogger();
    var memoizedBiData = useDeepEqualMemo(isOpen ? closeBiData : openBiData);
    var onClickWithBi = useCallback(function (event) {
        memoizedBiData && logBiEvent(memoizedBiData);
        setOpen(function (open) { return !open; });
        onClick && onClick(event);
    }, [memoizedBiData, logBiEvent, onClick]);
    var renderOption = function (_a) {
        var value = _a.value, label = _a.label, hidden = _a.hidden, disabled = _a.disabled, optionBiData = _a.biData;
        return (React.createElement(BiOption, { key: value, hidden: hidden, value: value, disabled: disabled, biData: optionBiData, label: label },
            label,
            ' '));
    };
    var renderOptGroup = function (_a) {
        var label = _a.label, disabled = _a.disabled, groupItems = _a.items;
        return (React.createElement("optgroup", { key: label, label: label, disabled: disabled }, groupItems.map(renderOption)));
    };
    return (React.createElement("select", { onChange: function (e) { return onSelect(e.target.value, e); }, onClick: onClickWithBi, className: className, name: name, value: selectedItem ? selectedItem.value : DUMMY_OPTION.value },
        !selectedItem && renderOption(DUMMY_OPTION),
        filteredItems.map(function (item) {
            return isDropdownGroup(item) ? renderOptGroup(item) : renderOption(item);
        })));
};
NativeDropdown.displayName = 'NativeDropdown';
export default NativeDropdown;
//# sourceMappingURL=NativeDropdown.js.map